/**
 * @fileoverview Configuration constants for the quote system
 */

export const QUOTE_CONFIG = {

  QUOTE_REDIRECT_URL: '/pages/demande-de-devis',

  CART_REDIRECT_URL: '/cart',
  
  QUOTE_BUTTON_SELECTOR: '.btn-devis',
  
  PRODUCT_DATA_ATTRIBUTE: 'data-product',
  
  LOG_PREFIX: '[collectionQuote]',
  
  DEFAULT_QUANTITY: 1


};

/**
 * @fileoverview Configuration constants for the product quote system
 */
export const PRODUCT_QUOTE_CONFIG = {

  LOG_PREFIX: '[productQuote]',
  
  QUOTE_REDIRECT_URL: '/pages/demande-de-devis',
  
  QUOTE_BUTTON_SELECTOR: '.btn-devis',
  
  PRODUCT_FORM_SELECTOR: '.product_form',
  
  PRODUCT_CONTEXT: 'product',
  
  SELECTORS: {
    VARIANT_ID: 'select[name="id"], input[name="id"]',
    COLOR_SWATCH: 'input[name="option-0"]:checked',
    QUANTITY: 'input[name="quantity"]',
    SWATCH: '.swatch input[type="radio"]'
  }
};
